import { useHistory, useLocation } from 'react-router-dom';
import { routerSearchParams } from 'ziphy-web-shared/basic/helpers';
export const useRouterSearchParams = (type = 'auto') => {
    const history = useHistory();
    const location = useLocation();
    return routerSearchParams({ history, location, type });
};
